import { render, staticRenderFns } from "./productDetail2.vue?vue&type=template&id=9cbc7ca4&scoped=true"
import script from "./productDetail2.vue?vue&type=script&lang=js"
export * from "./productDetail2.vue?vue&type=script&lang=js"
import style0 from "./productDetail2.vue?vue&type=style&index=0&id=9cbc7ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbc7ca4",
  null
  
)

export default component.exports